<template>
  <div>
    <v-row>
      <v-col cols="12">
        <campaign-tracking :items="lifetimeStatistics.campaignTracking" />
      </v-col>
      <v-col cols="12">
        <click-breakdown :items="lifetimeStatistics.clickBreakdown" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CampaignTracking from '@/components/Affiliates/Statistics/CampaignTracking'
import ClickBreakdown from '@/components/Affiliates/Statistics/ClickBreakdown'

export default {
  name: 'LifetimeReport',
  components: {
    CampaignTracking,
    ClickBreakdown,
  },
  computed: mapGetters({
    lifetimeStatistics: 'affiliates/lifetimeStatistics'
  }),
  methods: mapActions({
    getLifetimeStatistics: 'affiliates/getLifetimeStatistics',
    reportError: 'reportError'
  }),
  async mounted () {
    try {
      await this.getLifetimeStatistics()
    } catch (e) {
      this.reportError(e)
    }
  }
}
</script>

<style scoped>

</style>
